var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vulnerability-label"},[_vm._v("\n  Has Vulnerabilities\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }